import cn from 'classnames'
import {FC, PropsWithChildren} from 'react'

import {FORM_CONTAINER_PADDING_MOBILE} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type TabsProps = {isSticky?: boolean; maxWidth?: string; isCentered?: boolean}

export const Tabs: FC<PropsWithChildren<TabsProps>> = ({
  isSticky = false,
  maxWidth,
  isCentered = false,
  children,
}) => (
  <>
    <div className={cn('tabs-wrapper', isSticky && 'sticky', isCentered && 'centered')}>
      <ul className="tabs">{children}</ul>
    </div>

    <style jsx>{`
      .tabs-wrapper {
        position: relative;
        height: 52px;
        overflow-x: auto;
        overflow-y: hidden;
      }
      .tabs-wrapper.centered {
        display: flex;
        justify-content: center;
        justify-content: safe center;
      }
      .tabs {
        display: flex;
        position: relative;
      }
      .tabs:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: ${theme.palette.gray[200]};
        height: 2px;
        border-radius: 4px;
      }
      ::-webkit-scrollbar-track {
        height: 4px;
        background-color: transparent;
      }
      ::-webkit-scrollbar {
        height: 4px;
        background-color: transparent;
      }
      ::-webkit-scrollbar-thumb {
        height: 4px;
        border-radius: 4px;
        background-color: ${theme.palette.gray[300]};
      }
      .sticky {
        position: sticky;
        top: 0;
        z-index: 1;
        height: auto;
        background-color: ${theme.palette.background.default};
        box-shadow: 0 8px 24px 0 ${theme.palette.background.default};
      }
      .sticky .tabs {
        padding-top: ${theme.spacing[3]};
        max-width: ${maxWidth};
        margin: 0 auto;
      }
      @media ${USER_TABLET_SCREENSIZE} {
        .sticky .tabs {
          padding-top: ${theme.spacing[2]};
        }
      }
      @media ${MOBILE_SCREENSIZE} {
        .tabs-wrapper {
          margin-left: -${FORM_CONTAINER_PADDING_MOBILE};
          margin-right: -${FORM_CONTAINER_PADDING_MOBILE};
        }
        .tabs-wrapper.centered {
          justify-content: flex-start;
        }
        .tabs-wrapper.centered .tabs {
          width: 100%;
        }
        .tabs {
          padding-left: ${theme.spacing[2]};
          padding-right: ${theme.spacing[2]};
        }
        .sticky {
          margin-left: -${theme.spacing[4]};
          margin-right: -${theme.spacing[4]};
        }
        .sticky .tabs {
          justify-content: flex-start;
          padding-left: ${theme.spacing[4]};
          padding-right: ${theme.spacing[4]};
        }
      }
    `}</style>
  </>
)
